export default {
  CART_NAME: 'Cart',
  GO_CHECK_IT_OUT: "Today's Deals",
  SAVE_SHIPPING_FEE: {
    ADD: 'Add',
    REPURCHASE: 'Add ',
    OF_ELIIBLE_ITEMS_TO_QUALIFY_FOR_FREE_SHIPPING:
      ' of eligible items to qualify for FREE Shipping',
    MEET_FREE_SHIPPING: 'On Orders Over',
    COMPLETE_FREE_SHIPPING: ' Enjoy Free Shipping',
    ALREADY_FREE_SHIPPING: 'Already Enjoy ',
    QUALIFIES_FOR_FREE_SHIPPING_OVER: 'Qualifies for FREE shipping over ',
    SHORT_FREE_SHIPPING: 'Free Shipping',
    TO_QUALIFY_FOR_FREE_SHIPPING:
      'of eligible items to qualify for FREE shipping'
  },
  SUBTOTAL: 'Subtotal',
  CART_COUNTDOWN_TIME_FORMAT: 'DDd HH:mm:ss',
  ADD_ITEM_FOR_FREE_SHIPPING: 'Pick More Items',
  STROLL_AROUND_AGAIN: 'Add More',
  EXPLORE_MORE: 'See more',
  VIEW_DETAILS: 'View Details',
  PACK_UP: 'Collapse',
  PROMOTIONAL_DEDUCTION: 'Promo saved ',
  TOTAL_DE_DUCTION: 'Total Discount',
  NEW_CUSTOMERS_COUPON_REACH: 'New User Coupon',
  DEDUCTION: 'Discount',
  SHIPPING_FEE_SAVING: 'Shpg saved',
  REACH: 'on Orders Over',
  FREE_SHIPPING: 'Free Shipping',
  TOTAL_SAVINGS_ON_SHIPPING: 'Total Shipping Savings',
  ADD_ITEMS_FOR_FREE_SHIPPING: 'Recommendations',
  REC_PRODUCTS_UPDATED_HOURLY: 'Recommended Products Updated Hourly',
  EXCLUDE_SHIPPING_TAX: '(Excluding shipping and import fees)',
  TOTAL_AMOUNT: 'Total Products',
  SUB_TOTAL: 'Subtotal',
  RETURN_TO_CART: 'Back to Cart',
  ALL: 'All',
  DOTD_OR_SPECIAL_SALE_EVENT: 'Deals',
  REDUCE_THE_PRICE: 'Price Drop',
  ALREADY_SOLD_OUT: 'Sold Out',
  OUT_OF_STOCK_AT_PRESENT: 'Currently Out of Stock',
  THE_PRODUCT_WERE_SOLD_OUT: 'Product Sold Out',
  TEMPORARILY_OUT_OF_STOCK: 'Temporarily Out of Stock',
  THE_PRODUCT_ALREADY_SOLD_OUT:
    "You're Late ,The Following Products Have Been Sold Out, Removed from Your Selection",
  SHOPPING_CART_IS_EMPTY: 'Shopping cart is empty.',
  ADD_YOUR_FAVOURITE_ITEM_IN_IT: 'Add your favorite items in it.',
  CART_NO_DOTD_OR_SPECIAL_SALE_EVENT_ITEM: "No Today's Deal and Best Deal",
  CART_NO_REDUCETHEPRICE_ITEM: 'No Products on Sale',
  CART_NO_ALREADYSOLDOUT_ITEM: 'No Products sold out',
  PLEASE_ADD_DELIVERY_LOCATION: 'Please add a shipping address',
  TOTAL_AMOUNT_OF_PRODUCTS: 'Total Product Amount',
  COLLECT_SUCCESSFULLY: 'Successfully Moved In',
  COLLECT_FAILED: 'Failed to Move In',
  REMOVE_SUCCESSFULLY: 'Successfully Moved Out',
  REMOVE_FAILED: 'Failed to Move Out',
  DELETE_SUCCESSFULLY: 'Deleted successfully',
  INELIGIBLE_PRODUCT_CLEAR_SUCCESSFUL: 'Successfully Cleared Invalid Products',
  NO_SPACE_TO_CLEAR: 'No Space to Clear',
  GO_TO_CART: 'Go to Shopping Cart',
  ONE_CLICK_CLEAR: 'One-Click Clear',
  SHOPPING_CART_FULL_PROMPT:
    'Shopping Cart is Full  Please Clear Space Before Adding More',
  ALREADY_AUTOMATIC_PURCHASE_RESTRICTION: 'Automatic Purchase Limit',
  CART_EXCEEDED: 'Price Error  Please Delete Products and Recalculate',
  NOT_SELECT_PRODUCT: "You Haven't Selected Any Products",
  PLEASE_FILL_IN_THE_ADDRESS_FIRSTLY:
    'Please Fill in the Shipping Address Before Viewing the Details'
};
